var _circle, _path, _g, _circle2, _rect, _path2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_108)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9165,
    cy: 3.98126,
    r: 2.54199,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_520_108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 15,
    width: 28,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.228394 18.9676C0.228394 17.1541 1.69847 15.6841 3.51191 15.6841H22.3099C24.1233 15.6841 25.5934 17.1541 25.5934 18.9676C25.5934 20.781 24.1233 22.2511 22.3099 22.2511H3.51191C1.69847 22.2511 0.228394 20.781 0.228394 18.9676Z",
    fill: "white",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_520_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8272 22.4465C19.8272 25.7059 16.8586 28.4394 13.0778 28.4394C9.29693 28.4394 6.32837 25.7059 6.32837 22.4465C6.32837 19.1872 9.29693 16.4536 13.0778 16.4536C16.8586 16.4536 19.8272 19.1872 19.8272 22.4465Z",
    stroke: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.911,
    cy: 19.9401,
    r: 2.11328,
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.0295,
    y: 8.69287,
    width: 1.76567,
    height: 3.40708,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7781 11.8058H11.0549L13.0125 14.4657L14.7781 11.8058Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 7.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.916504,
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTim);
export default __webpack_public_path__ + "static/media/tim.71ad2c6b24b3895412849369cc000c96.svg";
export { ForwardRef as ReactComponent };